import React, { useContext } from 'react';
import { GlobalStateContext } from '../../../context/GlobalStateProvider';
import { faq } from '../../../../../app/config/faqConfig.json5';
import { LeftOutlined } from '@ant-design/icons';
import { Card, Button } from 'antd';

export const FAQ = ({ children }) => {
  const { isDesktop, isMobile, isTablet, changePaymentLayout } = useContext(
    GlobalStateContext
  );

  const getCardWidth = () => {
    if (isDesktop) {
      return '70%';
    }
    if (isTablet && !changePaymentLayout) {
      return '90%';
    }
    if (changePaymentLayout) {
      return '100%';
    }
  };

  const styles = {
    cardContainer: {
      width: getCardWidth(),
      margin: changePaymentLayout ? '' : 'auto',
      paddingBottom: '32px',
      paddingRight: !isDesktop ? 0 : '12em',
      paddingLeft: !isDesktop ? 0 : '12em',
    },
    sectionContainer: {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: '1em',
    },
    titleHeader: {
      display: 'flex',
      fontSize: isMobile ? '17px' : '28px',
      fontWeight: 'bold',
      marginLeft: '0.5em',
      marginBottom: '1.5em',
    },
  };
  const goBack = () => {
    window.history.back();
  };
  return (
    <Card style={styles.cardContainer}>
      <h1 style={styles.titleHeader}>Frequently Asked Questions</h1>
      {faq.map((item, index) => {
        return (
          <div style={styles.sectionContainer} key={'question-index-' + index}>
            <span style={{ fontWeight: 'bold', marginBottom: '0.15em' }}>
              {item.question}
            </span>
            <span style={{ marginBottom: '2em' }}>{item.answer}</span>
          </div>
        );
      })}
      <Button type='link' onClick={goBack} icon={<LeftOutlined />}>
        Back
      </Button>
    </Card>
  );
};
